import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 14rem 0 10rem;
  opacity: ${props => (props.inView ? '1' : '0')};
  transition: all 600ms var(--easeInOutCubic);

  @media (min-width: 600px) {
    margin: 20rem 0 var(--space-xxxl);
  }

  h2,
  p {
    font-size: 2rem;
    font-weight: var(--f-light);
    line-height: 3.2rem;

    @media (min-width: 850px) {
      font-size: 2.8rem;
    }
  }

  h2 {
    margin-bottom: var(--space-s);

    @media (min-width: 850px) {
      margin-bottom: var(--space-l);
    }
  }

  p {
    max-width: 60ch;
    margin-bottom: var(--space-l);

    @media (min-width: 600px) {
      margin-bottom: var(--space-xl);
    }

    @media (min-width: 850px) {
      line-height: 4.2rem;
    }
  }

  li {
    font-size: 2.8rem;
    line-height: 3.6rem;
    font-weight: var(--f-light);

    @media (min-width: 600px) {
      font-size: 3.2rem;
      line-height: 4rem;
    }

    @media (min-width: 850px) {
      font-size: 4.8rem;
      line-height: 6.4rem;
    }

    & + li {
      margin-top: var(--space-s);
    }
  }
`;

const Services = () => {
  const data = useStaticQuery(graphql`
    query {
      allPrismicHomepage {
        edges {
          node {
            data {
              services_title
              services_description
              services {
                service
              }
            }
          }
        }
      }
    }
  `);

  const servicesData = data.allPrismicHomepage.edges[0].node.data;

  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  return (
    <Wrapper ref={ref} inView={inView}>
      <h2>{servicesData.services_title}</h2>
      <p>{servicesData.services_description}</p>

      <ul>
        {servicesData.services.map(item => (
          <li key={item.service}>{item.service}</li>
        ))}
      </ul>
    </Wrapper>
  );
};

export default Services;
